module.exports = __webpack_public_path__ + "static/media/Apache-Tomcat.d43336bc.svg";